import React from 'react';
import { Link } from 'react-router-dom';
import linkedIn from '../images/linkedin.png';
import facebook from '../images/facebook.png';

export default function Footer() {

    return (
        <>
            <footer id="footer">
                <div className="main_footer">
                    <div className="footer_address_div">
                        <div className="footer_logo h2">Chrissron</div>
                        <div className="footer_office">
                            Head Office
                        </div>
                        <div className="footer_address">
                            Panakal house, Mosco road, Ancherichira, Thrissur, Kerala 680006, India
                        </div>
                        <div className="footer_email_div">
                            <a href="mailto:agrimass1985@gmail.com" className="footer_email" >
                                agrimass1985@gmail.com </a>
                        </div>
                        <div className="footer_phone">
                            <a href="tel:+916374244993" className="footer_email">6374244993</a>

                        </div>
                    </div>
                    <div className="footer_links_div">
                        <Link className='footer_links' to="/">Home</Link>
                        <Link className='footer_links' to="/bioplastics">Bioplastics</Link>
                        <Link className='footer_links' to="/about">About</Link>
                        <Link className='footer_links' to="mailto:agrimass1985@gmail.com">Contact us</Link>
                    </div>
                    <div className="footer_social_div">
                        <a href="https://www.linkedin.com" target="_blank">
                            <img src={linkedIn} className="contact_fly" id="linkedin" />
                        </a>
                        <a href="https://www.facebook.com" target="_blank">
                            <img src={facebook} className="contact_fly" id="facebook" />
                        </a>
                        {/* <a href="https://www.instagram.com" target="_blank">
                            <img src={instagram} className="contact_fly" id="instagram" />
                        </a> */}
                    </div>
                </div>

                <span className="footer_space">
                    <div style={{ marginBottom: "15px" }}>
                        &#169; Chrissron Biomass Solutions 2023
                    </div>

                </span>

            </footer>
        </>

    )
}
